import { DISABLED_OPACITY } from "../../../styles/colors/consts";
import { FontWeight } from "../../../types";

export default function getLinkStyles(
  disabled: boolean,
  disableInteractiveStyles: boolean,
  underline?: boolean,
  fontWeight?: FontWeight
) {
  const textDecoration =
    underline || fontWeight === "normal" ? "underline" : "none";

  if (disabled) {
    return {
      textDecoration,
      fontWeight,
      cursor: "not-allowed",
      opacity: DISABLED_OPACITY
    };
  }

  if (disableInteractiveStyles) {
    return {
      textDecoration,
      fontWeight,
      webkitTapHighlightColor: "transparent"
    };
  }

  return {
    textDecoration,
    fontWeight,
    hoverStyles: {
      textDecoration: "underline"
    },
    activeStyles: {
      textDecoration: "underline"
    },
    activeNavLinkStyles: {
      textDecoration: "underline"
    }
  };
}
